<!--
 * @Author: your name
 * @Date: 2020-03-03 11:06:44
 * @LastEditTime: 2020-05-11 15:01:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\src\components\common\GatFooter.vue
 -->
<template>
  <div class="gat-footer">
    <div class="footer-con">
      <div class="footer-logo">
        <img :src="Logo.img" alt="Logo" class="footer-logo-img" />
      </div>
      <div class="copyright-wrap">
        <p class="address"><span>地址：</span>深圳市龙岗区坂田街道稼先路2000号有所为大厦A座10层</p>
        <p class="address"><span>服务热线：</span>400-609-6665</p>
        <p class="copyright">Copyright © 2019-2021 深圳国匠云职业教育科技有限公司 版权所有&nbsp;&nbsp;粤ICP备2021135932号-1</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gat-head",
  data() {
    return {
      Logo: {
        img: require("../../../public/images/gjy-footerlogo.png")
      },
      CopyRight: {
        // copyright:
        //   "Copyright 2014-2020  深圳国匠云教育技术有限公司  粤ICP备05065871号-2",
        // address: "深圳市南山区学苑大道1001号南山智园A4",
        // telphone: "服务热线：400-609-6665"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.gat-footer {
  width: 100%;
  height: 146px;
  background: #08080A;

  .footer-con {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding-top: 34px;
    display: flex;
    box-sizing: border-box;

    .footer-logo {
      width: 150px;
      height: 32px;
    }
    .copyright-wrap {
      flex: 1;
      margin-left: 50px;
      line-height: 25px;
      text-align: left;
      p {
        color: #6F7076;
        font-size: 16px;
      }
    }
  }
}
</style>
